


// 需要登录的页面
import MemberIndex from '@/views/member/index'
import My from '@/views/member/my'
import Mortgage from '@/views/member/mortgage'
import Coupon from '@/views/member/coupon'
import Address from '@/views/member/address'
import Order from '@/views/member/order'
import OrderDetail from '@/views/member/orderDetail'
import Profile from '@/views/member/profile'
import Integral from '@/views/member/integral'
import IntegralRule from '@/views/member/integralRule'
import IntegralList from '@/views/member/integralList'
import Favorite from '@/views/member/favorite'
import Feedback from '@/views/member/feedback'
import About from '@/views/member/about'
import OrderConfirm from '@/views/member/orderConfirm'
import OrderSuccess from '@/views/member/orderSuccess'
import OrderPay from '@/views/member/orderPay'
import Cart from '@/views/member/cart'
import Distribution from '@/views/member/distribution'
import ReferList from '@/views/member/referList'
import NewStore from '@/views/member/newStore'

export default [

    {path: '/member',component:MemberIndex, name: 'member',children: [
        {path: 'my', name: 'my', component: My},
        {path: 'mortgage', name: 'mortgage', component: Mortgage},
        {path: 'coupon', name: 'coupon', component: Coupon},
        {path: 'address', name: 'address', component: Address},
        {path: 'order', name: 'order', component: Order},
        {path: 'orderDetail', name: 'orderDetail', component: OrderDetail},
        {path: 'profile', name: 'profile', component: Profile},
        {path: 'integral', name: 'integral', component: Integral},
        {path: 'integralRule', name: 'integralRule', component: IntegralRule},
        {path: 'integralList', name: 'integralList', component: IntegralList},
        {path: 'favorite', name: 'favorite', component: Favorite},
        {path: 'feedback', name: 'feedback', component: Feedback},
        {path: 'distribution', name: 'distribution', component: Distribution},
        {path: 'referList', name: 'referList', component: ReferList},
        {path: 'about', name: 'about', component: About},
        {path: 'apply',component:NewStore, name: 'newStore'},

        {path: '/orderConfirm',component:OrderConfirm, name: 'orderConfirm'},
        {path: '/orderSuccess',component:OrderSuccess, name: 'orderSuccess'},
        {path: '/cart',component:Cart, name: 'cart'},

        {path: '/pay/wx',component:OrderPay, name: 'orderPay'},
    ],redirect: '/member/my'},




]




// WEBPACK FOOTER //
// ./src/router/member.js